<template>
  <v-container grid-list-xs>
    <v-layout row wrap>
      <v-flex xs2>
        <v-text-field name="name" label="Name" id="name" v-model="extension.name"></v-text-field>
      </v-flex>
      <v-flex xs3>
        <v-text-field
          name="displayName"
          label="Display Name"
          id="displayName"
          v-model="extension.displayname"
        ></v-text-field>
      </v-flex>

      <v-flex xs2>
        <div v-for="(ext, index) in extension.alias" :key="index">
          <v-text-field
            :key="index"
            :name="`alias${index}`"
            label="Alias"
            id="alias"
            v-model="extension.alias[index]"
            clear-icon="delete"
            clearable
            @click:clear="delANI(ext)"
            append-icon="add"
            @click:append="addANI(ext)"
          ></v-text-field>
        </div>
      </v-flex>
      <v-flex xs2>
        <v-text-field name="ani" label="ANI" id="ani" v-model="extension.ani"></v-text-field>
      </v-flex>
      <v-flex xs1>
        <v-icon color="success" @click="save">save</v-icon>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script >
export default {
  name: "extensionDetail",
  props: {
    extension: {
      type: Object,
      required: true
    }
  },
  methods: {
    addANI(val) {
      this.extension.alias.push("");
    },
    delANI(val) {
      console.log(val);
    },
    save() {
      this.$emit("save", this.extension);
    }
  }
};
</script>
